/**
 * RFC 7807 problem+json, the only error shape the API returns. Screens render
 * `detail` verbatim next to the field or the action that failed; nothing calls
 * `alert()` and nothing swallows the server's explanation.
 */
export interface Problem {
  status: number;
  code: string;
  detail: string;
}

interface ProblemPayload {
  status?: unknown;
  code?: unknown;
  detail?: unknown;
}

export async function readProblem(response: Response): Promise<Problem> {
  const status = response.status;
  try {
    const payload = (await response.json()) as ProblemPayload;
    return {
      status,
      code: typeof payload.code === 'string' ? payload.code : `http.${status}`,
      detail: typeof payload.detail === 'string' ? payload.detail : response.statusText,
    };
  } catch {
    return { status, code: `http.${status}`, detail: response.statusText || `HTTP ${status}` };
  }
}

export function problemMessage(problem: Problem | null | undefined): string | null {
  if (problem === null || problem === undefined) {
    return null;
  }
  return problem.detail;
}
